import Crud from '../views/Area/Crud'
import Entity from '../views/Area/Add'

let routes = {
    path: '/areas',
    permission_name: 'Areas',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/areas/add',
            name: 'NewArea',
            permission_name: 'Criar área',
            component: Entity,
            meta: {
                pageTitle: 'Area',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Adicionar Area',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/areas/edit/:id?',
            name: 'EditArea',
            permission_name: 'Editar área',
            component: Entity,
            meta: {
                pageTitle: 'Area',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Editar Area',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/areas',
            name: 'list-areas',
            permission_name: 'Listar áreas',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Areas',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Areas',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
